<section class="page-home">
  <modulo-position position="banner-slider"></modulo-position>
  <modulo-position position="produto-regioes-destaques"></modulo-position>
  <modulo-position position="produto-categoria-destaque"></modulo-position>
</section>  
 



